/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react'
import ReactDOM from 'react-dom'
import Model from './index'
import Message from './Message'
import estyle from "./message.module.scss"
import Button from 'components/button'

const Fn: Function = () => ({})

export function createModel ({ children, onClose, style = {} }) {
  const div = document.createElement('div')
  document.body.appendChild(div)

  function handleClose () {
    onClose && onClose()
    ReactDOM.unmountComponentAtNode(div)
    document.body.removeChild(div)
  }

  ReactDOM.render(
    <Model
      style={style}
      onHide={handleClose}
      show={true}
    >
      { children }
    </Model>,
    div)

  return handleClose
}

function createMessage({ text, children, closeTime = 0, onClose = Fn, title = '提示'}) {
  const div = document.createElement('div')
  document.body.appendChild(div)

  function handleClose () {
    onClose && onClose()
    ReactDOM.unmountComponentAtNode(div)
    document.body.removeChild(div)
  }

  ReactDOM.render(
    <Message
      closeTime={closeTime}
      onHide={handleClose}
      show={true}
    >
      <div className={estyle['create-message']}>
        <div className={estyle.title}>{title}</div>
        <div className={estyle.text}>{text}</div>
        { children }
      </div>
    </Message>,
    div)

  return handleClose
}

function confirm({ cancelText = '返回', confirmText = '确定',text, onClose = Fn, onConfirm = Fn, onCancel = Fn, title = '提示', noCancel = false }) {

  let dom = (
    <div className={estyle.control}>
      <Button
        title={cancelText}
        onClick={handleCancel}
        type="gray"
        className={estyle.button}
      />
      <Button
        title={confirmText}
        onClick={handleConfirm}
        type="green"
        className={estyle.button}
      />
    </div>
  )

  if (noCancel) {
    dom = (
      <div className={estyle.control}>
        <Button
          title="确定"
          onClick={handleConfirm}
          type="green"
          className={estyle.button}
        />
      </div>
    )
  }

  const close = createMessage({ onClose, text, title, children: dom })
  
  function handleConfirm () {
    onConfirm()
    close()
  }

  function handleCancel () {
    onCancel()
    close()
  }

  return close
}

const ModelFn = {
  confirm
}

export default ModelFn
